import { useContext, useEffect, useState } from 'react'
import {  Outlet } from 'react-router-dom'
import { Dialog, Stack, DialogType,  DefaultButton } from '@fluentui/react'
import { useBoolean } from '@fluentui/react-hooks'
import { mergeStyles } from '@fluentui/react/lib/Styling';
import { Spinner } from '@fluentui/react';
import { useMediaQuery } from 'react-responsive';
import {  historyClear, ErrorMessage, Citation , ChatMessage} from '../../api'
import {  DeleteButton } from '../../components/common/Button'
import { AppStateContext } from '../../state/AppProvider'

import styles from './Layout.module.css'

const clearButtonStyles = mergeStyles({
  backgroundColor: '#001E60',
  color: 'white',
  borderRadius: '15px',
  fontWeight: 'bold',
 ':hover': {
  borderRadius: '15px',
    },
});

const closeButtonStyles = mergeStyles({
  backgroundColor: 'white',
  color: '#001E60',
  borderRadius: '15px',
  fontWeight: 'bold',
 ':hover': {
  borderRadius: '15px',
    },
});

const dialogFooterContainer = mergeStyles({
  display: 'flex',
  justifyContent: 'space-between'
});



const Layout = () => {
  const [isDeletePanelOpen, setIsDeletePanelOpen] = useState<boolean>(false)
  const [clearingChat, setClearingChat] = useState<boolean>(false)
  const [errorMsg, setErrorMsg] = useState<ErrorMessage | null>()
  const [hideErrorDialog, { toggle: toggleErrorDialog }] = useBoolean(true)
  const appStateContext = useContext(AppStateContext)
  const APP_ENVIRONMENT = appStateContext?.state.frontendSettings?.app_environment
  const appContainerVersion = appStateContext?.state.frontendSettings?.app_container_version
  const [appVersion, setAppVersion] = useState("")

  const handleDeleteClick = () => {
    setIsDeletePanelOpen(true)
  }
  useEffect(() => {
    if (APP_ENVIRONMENT!== "prd") {
      setAppVersion(appContainerVersion ?appContainerVersion:  '?.?.?')
    } else {
      setAppVersion("")
    }

  }, [APP_ENVIRONMENT, appContainerVersion])
  const handleClear = () => {
    clearChat()
 };

  const handleDeletePanelDismiss = () => {
    setIsDeletePanelOpen(false)
    setErrorMsg({title: '', subtitle:''})
  }

  const clearChat = async () => {
    setClearingChat(true)
    if (appStateContext?.state.currentChat?.id && appStateContext?.state.isCosmosDBAvailable.cosmosDB) {
      let response = await historyClear(appStateContext?.state.currentChat.id)
      if (!response.ok) {
        setErrorMsg({
          title: 'Error clearing current chat',
          subtitle: 'Please try again. If the problem persists, please contact the site administrator.'
        })
        toggleErrorDialog()
      } else {
        appStateContext?.dispatch({
          type: 'DELETE_CURRENT_CHAT_MESSAGES',
          payload: appStateContext?.state.currentChat.id
        })
        appStateContext?.dispatch({ type: 'UPDATE_CHAT_HISTORY', payload: appStateContext?.state.currentChat })       
      }
    }
    setIsDeletePanelOpen(!isDeletePanelOpen)
    setTimeout(() => {
      setClearingChat(false)
    }, 2000)
    
  }
  const errorDialogContentProps = {
    type: DialogType.close,
    title: errorMsg?.title,
    closeButtonAriaLabel: 'Close',
    subText: errorMsg?.subtitle
  }


  const handleErrorDialogClose = () => {
    toggleErrorDialog()
    setTimeout(() => {
      setErrorMsg(null)
    }, 500)
  }
  useEffect(() => {}, [appStateContext?.state.isCosmosDBAvailable.status])

  const isDesktopScreen = useMediaQuery({ query: '(min-width: 900px)' })
  return (
    <div className={styles.layout}>
      <div className={styles.layoutBanner}>
      <header className={styles.header} role='banner'>
        <Stack horizontal verticalAlign="center" horizontalAlign="space-between">
          <Stack>{ appVersion && <div style={{
            marginLeft: '25px', fontSize: '15px'
          }}> v{appVersion}</div> }</Stack>
          <Stack horizontal verticalAlign="center">
            <div className={styles.headerTitleContainer} style={{ marginLeft: '0px'}}>
            <h1 className={styles.headerTitle}>
            <span className={styles.headerTitleFirstPart}>ASK&nbsp;</span> 
            <span className={styles.headerTitleSecondPart} >SAMMY</span>
          </h1>
            </div>
          </Stack>
          <Stack horizontal tokens={{ childrenGap: 4 }} className={styles.newChatButtonContainer}>

            {isDesktopScreen && <DeleteButton onClick={handleDeleteClick}/>}
          </Stack>
        </Stack>
      </header>
      </div>
      <Outlet />
     <Dialog
                  hidden={hideErrorDialog}
                  onDismiss={handleErrorDialogClose}
                  dialogContentProps={errorDialogContentProps}
                  ></Dialog>
       
      <Dialog
        onDismiss={handleDeletePanelDismiss}
        hidden={!isDeletePanelOpen}
        styles={{
          main: [
            {
              selectors: {
                ['@media (min-width: 480px)']: {
                  maxWidth: '600px',
                  background: '#FFFFFF',
                  boxShadow: '0px 14px 28.8px rgba(0, 0, 0, 0.24), 0px 0px 8px rgba(0, 0, 0, 0.2)',
                  borderRadius: '8px',
                  maxHeight: '200px',
                  minHeight: '100px',
                }
              }
            }
          ]
        }}
        dialogContentProps={{
          title:  'Are you sure you want to start a new chat?',
          showCloseButton: false,
          styles: {
            title: {
              color: '#001E60' 
            }
          }
        }}>
        <Stack horizontal horizontalAlign="center" verticalAlign="center" style={{ gap: '8px' }}>
        {clearingChat ? <Spinner /> 
        :<><DefaultButton className={clearButtonStyles} onClick={handleClear} text="Confirm" />
        <DefaultButton className={closeButtonStyles} onClick={handleDeletePanelDismiss} text="Close" /></>
        }  
 </Stack>       
      </Dialog>
    </div>
  )
}

export default Layout
